// Actions
export const FETCH_COMMENTS = '@@hfty-comments/FETCH_COMMENTS'
export const FETCH_HEFTY_CROPS = '@@hfty-comments/FETCH_HEFTY_CROPS'

// State Configuration
export const TREE = 'commentsData'
export const BRANCH = 'comments'
